import { AxiosRequestConfig } from "axios";
import { CohesiveAPIClient } from "../../client";
import {
  AxiosRequestConfigTypedParams,
  InboxItemResponse,
  InboxItemsGetParams,
  InboxItemsResponse,
  UpdateInboxItemRequest,
} from "./types";

import { route } from "../../utils";

export * from "./types";

const ENDPOINTS = {
  LIST: "/api/v2/org/:organization_id/user/:user_id/inbox-items",
  UPDATE:
    "/api/v2/org/:organization_id/user/:user_id/inbox-items/:inbox_item_id",
};

export class InboxAPI {
  constructor(private client: CohesiveAPIClient) {}

  async list(
    config?: AxiosRequestConfigTypedParams<
      InboxItemsResponse,
      InboxItemsGetParams
    >,
  ): Promise<InboxItemsResponse> {
    const organizationId = await this.client.getOrgID();
    const userId = await this.client.getUserID();

    const response = await this.client.axios.get<InboxItemsResponse>(
      route(ENDPOINTS.LIST, {
        organization_id: organizationId,
        user_id: userId,
      }),
      config,
    );
    return response.data;
  }

  async update(
    id: string,
    data: UpdateInboxItemRequest,
    config?: AxiosRequestConfig,
  ): Promise<InboxItemResponse> {
    const organizationId = await this.client.getOrgID();
    const userId = await this.client.getUserID();

    const response = await this.client.axios.put<InboxItemResponse>(
      route(ENDPOINTS.UPDATE, {
        organization_id: organizationId,
        user_id: userId,
        inbox_item_id: id,
      }),
      data,
      config,
    );
    return response.data;
  }
}
